/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Dl_File_Win_X64_Msi_DescInputs */

const en_pc_dl_file_win_x64_msi_desc = /** @type {(inputs: Pc_Dl_File_Win_X64_Msi_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Most Windows 10 and 11 PCs.`)
};

const zh_pc_dl_file_win_x64_msi_desc = /** @type {(inputs: Pc_Dl_File_Win_X64_Msi_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`适用于大多数 Windows 10 / 11 电脑。`)
};

/**
* | output |
* | --- |
* | "Most Windows 10 and 11 PCs." |
*
* @param {Pc_Dl_File_Win_X64_Msi_DescInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_dl_file_win_x64_msi_desc = /** @type {((inputs?: Pc_Dl_File_Win_X64_Msi_DescInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Dl_File_Win_X64_Msi_DescInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_dl_file_win_x64_msi_desc(inputs)
	return zh_pc_dl_file_win_x64_msi_desc(inputs)
});
export { pc_dl_file_win_x64_msi_desc as "pc.dl.file.win_x64_msi.desc" }